import React from "react";
import { KgCalendarIcon } from "../KgCalendarIcon/KgCalendarIcon";
import { ChevronDownIcon } from "../ChevronDownIcon/ChevronDownIcon";
import { IconSlot, Label, Trigger } from "./InlinePickTrigger.styles";

export interface InlinePickTriggerProps {
  /** The picked value's text; empty shows `placeholder`. */
  label: string;
  open: boolean;
  placeholder?: string;
  icon?: "chevron" | "calendar";
  invalid?: boolean;
  disabled?: boolean;
  ariaLabel: string;
  ariaHasPopup?: "listbox" | "dialog";
  onClick: () => void;
}

/**
 * A picker button sized to sit inside a sentence ("Every [2] [weeks] at [9:00 AM]").
 * Pass it to `Dropdown`'s `trigger` prop; the caller owns `ref` and `onClick`.
 */
export const InlinePickTrigger = React.forwardRef<HTMLButtonElement, InlinePickTriggerProps>(
  ({ label, open, placeholder = "", icon = "chevron", invalid = false, disabled = false, ariaLabel, ariaHasPopup = "listbox", onClick }, ref) => (
    <Trigger
      ref={ref}
      type="button"
      aria-haspopup={ariaHasPopup}
      aria-expanded={open}
      aria-label={ariaLabel}
      aria-invalid={invalid || undefined}
      disabled={disabled}
      $open={open}
      $invalid={invalid}
      $placeholder={!label}
      onClick={onClick}
    >
      <Label>{label || placeholder}</Label>
      <IconSlot>{icon === "calendar" ? <KgCalendarIcon size={16} /> : <ChevronDownIcon size={16} />}</IconSlot>
    </Trigger>
  ),
);
InlinePickTrigger.displayName = "InlinePickTrigger";

export default InlinePickTrigger;
